import { render, staticRenderFns } from "./heiferReproductiveStatus.vue?vue&type=template&id=83364d3c&scoped=true&"
import script from "./heiferReproductiveStatus.vue?vue&type=script&lang=js&"
export * from "./heiferReproductiveStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83364d3c",
  null
  
)

export default component.exports